import React from "react";
import {
  AppstoreOutlined,
  MenuOutlined,
  MessageOutlined,
  ProductOutlined,
} from "@ant-design/icons";

const NAV_ITEMS = [
  { id: "menu", label: "MENU", Icon: MenuOutlined },
  { id: "dashboard", label: "DASHBOARD", Icon: AppstoreOutlined },
  { id: "products", label: "PRODUCTS", Icon: ProductOutlined },
  { id: "copilot", label: "COPILOT", Icon: MessageOutlined },
];

export default function MobileBottomNav({ activeId, onMenu, onDashboard, onProducts, onCopilot }) {
  const handlers = {
    menu: onMenu,
    dashboard: onDashboard,
    products: onProducts,
    copilot: onCopilot,
  };

  return (
    <nav className="sv-mobile-nav" aria-label="Main navigation">
      {NAV_ITEMS.map(({ id, label, Icon }) => {
        const isActive = activeId === id;
        return (
          <button
            key={id}
            type="button"
            className={`sv-mobile-nav__item${isActive ? " sv-mobile-nav__item--active" : ""}`}
            onClick={handlers[id]}
            aria-current={isActive ? "page" : undefined}
          >
            <Icon className="sv-mobile-nav__icon" />
            <span className="sv-mobile-nav__label">{label}</span>
            {isActive && <span className="sv-mobile-nav__indicator" aria-hidden />}
          </button>
        );
      })}
    </nav>
  );
}
